import { render, staticRenderFns } from "./TermsWeb.vue?vue&type=template&id=73e401cd&scoped=true&"
import script from "./TermsWeb.vue?vue&type=script&lang=js&"
export * from "./TermsWeb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e401cd",
  null
  
)

export default component.exports